import { render, staticRenderFns } from "./acto.vue?vue&type=template&id=7e9245a0&"
import script from "./acto.vue?vue&type=script&lang=js&"
export * from "./acto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports